export default __webpack_public_path__ + "static/media/barrels.26c2d92a.png";